import { atom } from 'recoil';

export const dialogOpenState = atom<boolean>({
  key: 'paymentMethodDialogOpenState',
  default: false,
});
